<template>
  <div class="row">
    <div class="col-12 card card-custom">
      <div class="card-body py-0 border-bottom">
        <ul class="nav nav-tabs nav-tabs-line border-bottom-0" role="tablist">
          <li v-if="$auth.isResourceFromIndex('users')" class="nav-item mr-14 mt-4">
            <router-link :to="{ name: '/sunbeds/view/:guid/statistics/overall' }" class="nav-link font-weight-bold border-2 pb-6 mx-0" data-toggle="tab" active-class="active">
              <span class="nav-icon">
                <i>
                  <font-awesome-icon :icon="['fas', 'list']" />
                </i>
              </span>
              <span class="nav-text">Overall</span>
            </router-link>
          </li>

          <li v-if="$auth.isResourceFromIndex('users') && $auth.hasPermission('equipment.statistics.session_performance')" class="nav-item mr-14 mt-4">
            <router-link :to="{ name: '/sunbeds/view/:guid/statistics/performance' }" class="nav-link font-weight-bold border-2 pb-6 mx-0" data-toggle="tab" active-class="active">
              <span class="nav-icon">
                <i>
                  <font-awesome-icon :icon="['fas', 'power-off']" />
                </i>
              </span>
              <span class="nav-text">Performance</span>
            </router-link>
          </li>

          <li v-if="$auth.isResourceFromIndex('users') && $auth.hasPermission('equipment.statistics.sessions')" class="nav-item mr-14 mt-4">
            <router-link :to="{ name: '/sunbeds/view/:guid/statistics/sessions' }" class="nav-link font-weight-bold border-2 pb-6 mx-0" data-toggle="tab" active-class="active">
              <span class="nav-icon">
                <i>
                  <font-awesome-icon :icon="['fas', 'chart-line']" />
                </i>
              </span>
              <span class="nav-text">Sessions</span>
            </router-link>
          </li>

          <li v-if="$auth.isResourceFromIndex('users') && $auth.hasPermission('equipment.statistics.sessions')" class="nav-item mr-14 mt-4">
            <router-link :to="{ name: '/sunbeds/view/:guid/statistics/peak-hours' }" class="nav-link font-weight-bold border-2 pb-6 mx-0" data-toggle="tab" active-class="active">
              <span class="nav-icon">
                <i>
                  <font-awesome-icon :icon="['fas', 'chart-scatter']" />
                </i>
              </span>
              <span class="nav-text">Peak hours</span>
            </router-link>
          </li>

          <li v-if="$auth.isResourceFromIndex('users') && $auth.hasPermission('equipment.statistics.sessions')" class="nav-item mr-14 mt-4">
            <router-link :to="{ name: '/sunbeds/view/:guid/statistics/key-figures' }" class="nav-link font-weight-bold border-2 pb-6 mx-0" data-toggle="tab" active-class="active">
              <span class="nav-icon">
                <i>
                  <font-awesome-icon :icon="['fas', 'key']" />
                </i>
              </span>
              <span class="nav-text">Key figures</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="card-body">
        <router-view
          ref="router-view"
          :equipment="equipment"
          :device="device"
        />
      </div>
    </div>
  </div>
</template>

<script>
import equipmentMixin from '@/components/pages/sunbeds/view/libs/mixin';

export default {
  mixins: [equipmentMixin],
};
</script>
